<sim-basic-material-dialog
	(closeClicked)="closeDialog()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-cube', fontSet: 'fad'}"
	[headerText]="T.SCENARIO_CREATE_SESSION | translate"
	[matDialogData]="data"
	[overflowHandledByChild]="true"
	[rect]="rect"
>
	<ng-container dialogContent>
		<sim-component-loading-container [isLoading]="stateService.isLoading()" [showBackDrop]="true" loadingIcon="fad fa-cube" />

		<mat-stepper #sessionStepper [linear]="true" labelPosition="bottom" orientation="horizontal">
			@if (!stateService.isLoading()) {
				<!--STEP 1-->
				<mat-step
					[completed]="stateService.step1Form.valid"
					[editable]="true"
					[stepControl]="stateService.step1Form"
					errorMessage="error"
				>
					<ng-template matStepLabel>
						{{ T.CREATE_SESSION_DIALOG_EXAM_METADATA | translate }}
					</ng-template>
					<ng-template matStepContent>
						<sim-team-training-session-step1 [eventEndDate]="data.eventEndDate" [eventStartDate]="data.eventStartDate" />
					</ng-template>
				</mat-step>

				<!--STEP 2-->
				<mat-step
					[completed]="stateService.step2Form.valid"
					[editable]="true"
					[stepControl]="stateService.step2Form"
					errorMessage="error"
				>
					<ng-template matStepLabel> Scenarios </ng-template>
					<ng-template matStepContent>
						<sim-team-training-session-step2 />
					</ng-template>
				</mat-step>

				<!--STEP 3-->
				<mat-step
					[completed]="stateService.step1Form.valid && stateService.step2Form?.valid"
					[editable]="true"
					errorMessage="error"
				>
					<ng-template matStepLabel> Participants </ng-template>
					<ng-template matStepContent>
						<sim-team-training-session-step3 />
					</ng-template>
				</mat-step>
			}
		</mat-stepper>
	</ng-container>

	<ng-container actions>
		<!--AUTOSAVE-->
		<sim-autosave-widget
			[promise]="stateService.autosavePromise"
			[timestamp]="stateService.session?.lastUpdateTime"
			[warningMessage]="stateService.autosaveWarning"
		/>

		<!--NAV BUTTONS-->
		@if (stepper()?.selectedIndex !== 2) {
			<sim-button
				(onClick)="stepper().next()"
				[disabled]="!stepper().selected?.completed"
				[icon]="{fontSet: 'fad', fontIcon: 'fa-step-forward'}"
				[label]="T.BUTTON_NEXT"
				color="accent"
			/>
		} @else {
			<sim-button
				(onClick)="closeDialog()"
				[disabled]="currentStepForm()?.invalid"
				[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
				[label]="T.BUTTON_FINISH"
				color="accent"
			/>
		}
	</ng-container>
</sim-basic-material-dialog>
